var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { resolveStrokeWidth, strokeContextForCanvas, getActiveDiagram } from '../theme';
import { autoLayoutNodesResponsive, createDiagramGroup, normalizeDiagramData, readCanvasSize, separateOverlappingNodes, } from '../helpers';
import { createNetworkNode, } from '../primitives';
import { collectObstacles } from '../router';
import { connectNodePairs } from '../connectors';
import { listNetworkIconKinds } from '../networkIcons';
import { maybeApplyDiagramFlow } from '../flow';
/** Create network topology diagram */
export function createNetworkDiagram(app, data, options) {
    var e_1, _a, e_2, _b, e_3, _c;
    var _d, _e, _f;
    if (options === void 0) { options = {}; }
    var group = createDiagramGroup(app, 'networkTopology', __assign(__assign({}, options), { data: data }), { name: 'network' });
    var _g = normalizeDiagramData(data), nodes = _g.nodes, edges = _g.edges;
    var canvas = readCanvasSize(options);
    var strokeCtx = strokeContextForCanvas(canvas.width, canvas.height);
    var edgeWidth = resolveStrokeWidth(getActiveDiagram().stroke.edge, strokeCtx);
    autoLayoutNodesResponsive(nodes, canvas.width, canvas.height, 100, 72);
    var nodeMap = new Map();
    try {
        for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var n = nodes_1_1.value;
            var nodeGroup = createNetworkNode(app, n.label, (_d = n.type) !== null && _d !== void 0 ? _d : 'default');
            nodeGroup.x = (_e = n.x) !== null && _e !== void 0 ? _e : 0;
            nodeGroup.y = (_f = n.y) !== null && _f !== void 0 ? _f : 0;
            if (typeof n.rotation === 'number')
                nodeGroup.rotation = n.rotation;
            nodeGroup.metadata = __assign(__assign({}, nodeGroup.metadata), { diagramId: n.id });
            nodeMap.set(n.id, nodeGroup);
            group.add(nodeGroup);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    separateOverlappingNodes(__spreadArray([], __read(nodeMap.values()), false), {
        gap: 20,
        canvasW: canvas.width,
        canvasH: canvas.height,
    });
    var allNodes = __spreadArray([], __read(nodeMap.values()), false);
    var obstacles = collectObstacles(allNodes);
    var edgeLayer = app.group({ zIndex: -10, listening: false });
    edgeLayer.metadata.diagramEdgeLayer = true;
    var pairs = [];
    try {
        for (var edges_1 = __values(edges), edges_1_1 = edges_1.next(); !edges_1_1.done; edges_1_1 = edges_1.next()) {
            var edge = edges_1_1.value;
            var from = nodeMap.get(edge.from);
            var to = nodeMap.get(edge.to);
            if (!from || !to)
                continue;
            pairs.push({
                from: from,
                to: to,
                options: {
                    label: edge.label,
                    edgeId: "".concat(edge.from, "->").concat(edge.to),
                    fromId: edge.from,
                    toId: edge.to,
                },
            });
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (edges_1_1 && !edges_1_1.done && (_b = edges_1.return)) _b.call(edges_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    try {
        for (var _h = __values(connectNodePairs(app, pairs, {
            parent: group,
            obstacleNodes: allNodes,
            obstacles: obstacles,
            stroke: getActiveDiagram().edge,
            glowColor: getActiveDiagram().edgeGlow,
            glow: false,
            strokeWidth: edgeWidth,
            cornerRadius: 10,
            style: 'smart',
        })), _j = _h.next(); !_j.done; _j = _h.next()) {
            var g = _j.value;
            edgeLayer.add(g);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
        }
        finally { if (e_3) throw e_3.error; }
    }
    group.add(edgeLayer);
    maybeApplyDiagramFlow(app, group, options);
    return group;
}
/**
 * Grid catalog of standard network icons (one tile per canonical kind).
 * Pass `category` to filter (e.g. 'security', 'iot').
 */
export function createNetworkIconCatalog(app, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var category = options.category;
    var kinds = listNetworkIconKinds().filter(function (m) { return !category || m.category === category; });
    var columns = Math.max(4, (_a = options.columns) !== null && _a !== void 0 ? _a : 8);
    var canvas = readCanvasSize(options);
    var group = createDiagramGroup(app, 'networkIconCatalog', __assign(__assign({}, options), { category: category }), { name: 'networkCatalog' });
    var gapX = 104;
    var gapY = 100;
    var startX = 20;
    var startY = 12;
    kinds.forEach(function (meta, i) {
        var col = i % columns;
        var row = Math.floor(i / columns);
        var node = createNetworkNode(app, meta.label, meta.kind);
        node.x = startX + col * gapX;
        node.y = startY + row * gapY;
        node.metadata = __assign(__assign({}, node.metadata), { diagramId: meta.kind });
        group.add(node);
    });
    // Keep canvas size metadata for fitToBounds
    void canvas;
    return group;
}
